import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { StreamsMetrics } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const POLL_INTERVAL_MS = 6e4;
export const fetchStreamMetrics = (streamIds, fields) => StreamsMetrics.getMetrics({ stream_ids: streamIds, fields }, { requestShouldExtendSession: false });
const sortedUnique = (values) => Array.from(new Set(values)).sort();
const useStreamMetrics = (streamIds, fields) => {
  var _a;
  const stableIds = sortedUnique(streamIds);
  const stableFields = sortedUnique(fields);
  const enabled = stableIds.length > 0 && stableFields.length > 0;
  const { data, isInitialLoading, isError } = useQuery({
    queryKey: ["streams", "metrics", stableIds, stableFields],
    queryFn: () => defaultOnError(
      fetchStreamMetrics(stableIds, stableFields),
      "Loading stream metrics failed with status",
      "Could not load stream metrics"
    ),
    enabled,
    placeholderData: keepPreviousData,
    refetchInterval: POLL_INTERVAL_MS
  });
  return {
    metricsByStreamId: (_a = data == null ? void 0 : data.metrics) != null ? _a : {},
    isInitialLoading,
    isError
  };
};
export default useStreamMetrics;
